import { useAtomValue } from 'jotai';
import { useTranslation } from '@wojtekmaj/react-t';

import { Link, Wrapper } from './header.styles';

import Avatar from '../../common/avatar';

import { currentUserState } from '../../../store';

export default function Header() {
  const currentUser = useAtomValue(currentUserState);
  const profileString = useTranslation('Profile');

  return (
    <Wrapper>
      <Link aria-label={profileString} to="/profile">
        <Avatar size={44} user={currentUser} />
      </Link>
    </Wrapper>
  );
}
